import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from 'react';
import { useTasksContext } from '../../../shared/contexts/TasksContext';

const FilterContext = createContext(null);

/** Default filter when no per-file preference is saved (Organize view). */
const DEFAULT_FILTER = 'all';

export function FilterProvider({ children }) {
  const { currentFileId } = useTasksContext();
  const [filter, setFilterState] = useState(DEFAULT_FILTER);
  const [timeFilter, setTimeFilter] = useState(null);
  const filterByFileIdRef = useRef(new Map());

  // When switching files, restore that file's view (Organize vs Prioritize) or default to Organize
  useEffect(() => {
    if (currentFileId == null) return;
    const saved = filterByFileIdRef.current.get(String(currentFileId));
    setFilterState(saved ?? DEFAULT_FILTER);
  }, [currentFileId]);

  const setFilter = useCallback((value) => {
    setFilterState(value);
    if (currentFileId != null) {
      filterByFileIdRef.current.set(String(currentFileId), value);
    }
  }, [currentFileId]);

  return (
    <FilterContext.Provider value={{ filter, setFilter, timeFilter, setTimeFilter }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilterContext() {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
}
